import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalFormPqr({
  pqrSelect,
  callback,
  title,
  button_text,
  button_variant,
}) {
  const [show, setShow] = useState(false);
  const [pqrTypes, setPqrTypes] = useState([]);
  const [infoForm, setForm] = useState({
    id_type: '',
    client_name: '',
    client_phone: '',
    client_email: '',
    client_document: '',
    description: '',
    priority: 'medium',
    office_id: '',
    inspection_id: '',
  });

  const handleClose = () => {
    setShow(false);
    setForm({
      id_type: '',
      client_name: '',
      client_phone: '',
      client_email: '',
      client_document: '',
      description: '',
      priority: 'medium',
      office_id: '',
      inspection_id: '',
    });
  };

  const handleShow = async (pqrId) => {
    const responseTypes = await get('/pqr/type/', {});
    if (responseTypes.success) {
      setPqrTypes(responseTypes.data);
    }
    if (pqrId) {
      const response = await get('/pqr/' + pqrId);
      if (response.success) {
        const d = response.data;
        setForm({
          id_type: d.type_id || '',
          client_name: d.client_name || '',
          client_phone: d.client_phone || '',
          client_email: d.client_email || '',
          client_document: d.client_document || '',
          description: d.description || '',
          priority: d.priority || 'medium',
          office_id: d.office_id || '',
          inspection_id: d.inspection_id || '',
        });
      }
    }
    setShow(true);
  };

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    let respo,
      variant = '',
      msg = '';

    const body = {
      id_type: infoForm.id_type,
      client_name: infoForm.client_name,
      client_phone: infoForm.client_phone,
      client_email: infoForm.client_email,
      client_document: infoForm.client_document,
      description: infoForm.description,
      priority: infoForm.priority,
      office_id: infoForm.office_id || undefined,
      inspection_id: infoForm.inspection_id || undefined,
    };

    if (pqrSelect) {
      respo = await put('/pqr/modify/' + pqrSelect, body);
      msg = 'PQR editada correctamente';
    } else {
      respo = await post('/pqr/create', body);
      msg = 'PQR creada correctamente';
    }

    if (respo.success) {
      variant = 'success';
    } else {
      variant = 'danger';
      msg = respo.message;
    }
    handleClose();
    callback(variant, msg);
  };

  useEffect(() => {
    const initForm = async () => {};
    initForm();
  }, []);

  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow(pqrSelect)}
      />

      <Modal animation={false} fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form.Label htmlFor="id_type">Tipo de PQR</Form.Label>
            <Form.Select
              className="mb-4"
              name="id_type"
              value={infoForm.id_type}
              onChange={(e) => handleForm(e)}
            >
              <option value="">Seleccione un tipo</option>
              {pqrTypes.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </Form.Select>

            <Form.Label htmlFor="client_name">Nombre del cliente</Form.Label>
            <Form.Control
              className="mb-4"
              name="client_name"
              value={infoForm.client_name}
              onChange={(e) => handleForm(e)}
              type="text"
            />

            <Form.Label htmlFor="client_phone">Teléfono</Form.Label>
            <Form.Control
              className="mb-4"
              name="client_phone"
              value={infoForm.client_phone}
              onChange={(e) => handleForm(e)}
              type="text"
            />

            <Form.Label htmlFor="client_email">Correo electrónico</Form.Label>
            <Form.Control
              className="mb-4"
              name="client_email"
              value={infoForm.client_email}
              onChange={(e) => handleForm(e)}
              type="email"
            />

            <Form.Label htmlFor="client_document">Documento</Form.Label>
            <Form.Control
              className="mb-4"
              name="client_document"
              value={infoForm.client_document}
              onChange={(e) => handleForm(e)}
              type="text"
            />

            <Form.Label htmlFor="description">Descripción</Form.Label>
            <Form.Control
              className="mb-4"
              name="description"
              value={infoForm.description}
              onChange={(e) => handleForm(e)}
              as="textarea"
              rows={3}
            />

            <Form.Label htmlFor="priority">Prioridad</Form.Label>
            <Form.Select
              className="mb-4"
              name="priority"
              value={infoForm.priority}
              onChange={(e) => handleForm(e)}
            >
              <option value="low">Baja</option>
              <option value="medium">Media</option>
              <option value="high">Alta</option>
              <option value="urgent">Urgente</option>
            </Form.Select>

            <Row className="text-center mb-2">
              <Col className="buttons-container">
                <Button variant="secondary" onClick={handleClose}>
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  onClick={(e) => saveForm(e)}
                >
                  Guardar Informacion
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormPqr;
